import React from 'react';
import { Button, Modal } from "antd";



import './EachSyncReport.scss';


const EachSyncReport = (props) => {
    return (
        <div>
            <ul>
                <li>{props.source}</li>
                <li>{props.destination}</li>
                <li>{props.syncFrequency}</li>
                <li><span>{props.date}</span></li>
                <li>
                    <Button
                        icon="delete"
                        onClick={e =>
                            showDeleteConfirm(e, props.handleDeleteClick, props.id, (props.source + " > " + props.destination))
                          }
                    />
                </li>
            </ul>
        </div>
    )
}

const showDeleteConfirm = (
    e,
    handleDeleteClick,
    syncId,
    destination
  ) => {
    e.stopPropagation()
    Modal.confirm({
      title: `Do you want to remove the ${destination} Sync Information?`,
      content:
        "This will only remove your Sync Information from CloudFlyer.",
      onOk() {
        handleDeleteClick(syncId)
      }
    })
  }
  

export default EachSyncReport;